export default () => Math.random().toString(36).replace('.', '').substr(2);
